import { toJS } from 'mobx';
import _ from 'lodash';
function deepToJS(value, deep = 30) {
    if (deep <= 0) {
        return value;
    }
    deep--;
    if (_.isArray(value)) {
        value = value.map((x) => deepToJS(x, deep));
    }
    else if (_.isMap(value)) {
        const tmp = [];
        value.forEach((v, k) => tmp.push({ mapId: k, value: deepToJS(v, deep) }));
        return tmp;
    }
    else if (_.isSet(value)) {
        const tmp = [];
        value.forEach((v, k) => tmp.push({ mapId: k, value: deepToJS(v, deep) }));
        return deepToJS(Array.from(value), deep);
    }
    else if (_.isObject(value)) {
        return _.mapValues(value, (x) => deepToJS(x, deep));
    }
    return value;
}
console.djs = function consoleDJSCustom(...args) {
    console.log(...deepToJS(args));
};
function deepMobxToJS(value) {
    if (_.isArray(value)) {
        return value.map(deepMobxToJS);
    }
    if (_.isPlainObject(value)) {
        const plain = toJS(value);
        return _.mapValues(plain, deepMobxToJS);
    }
    if (value instanceof Map) {
        const plain = toJS(value);
        return new Map(Array.from(plain.entries()).map(([k, v]) => [k, deepMobxToJS(v)]));
    }
    if (value instanceof Set) {
        const plain = toJS(value);
        return new Set(Array.from(plain).map(deepMobxToJS));
    }
    return toJS(value);
}
console.js = (...args) => {
    console.log(...args.map(deepMobxToJS));
};
